exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".record-details-map{width:auto;margin-left:-15px;margin-top:-15px;margin-right:-15px;height:500px}.record-details-title{overflow-wrap:break-word;word-wrap:break-word;float:left;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/~/eoxc/src/search/views/RecordDetailsView.css
// module id = 1983
// module chunks = 0